import Reaction from './Reaction';

export const commonModels = {
  Reaction,
};
